// src/theme/index.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1A4B2A', // Sua cor principal aqui
      light: '#c6f0d4',
      dark: '#00200b',
    },
    secondary: {
      main: '#2a7944', // Sua cor secundária
    },
    background: {
      default: '#f5f5f5',
    },
  },
  // Você também pode centralizar fontes e bordas aqui
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

export default theme;